import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    PlayArrow,
    ChevronLeft,
    Pause,
    Person,
    LocationOn,
    CloudUpload,
    Replay,
    PlayCircleFilled,
    StopCircle 
} from '@mui/icons-material';
import './Home.css';
import key from '../../assets/svg/wrench (1) 1.svg';
import sos from '../../assets/svg/Sos.svg';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';

const Home = () => {

    const navigate = useNavigate();
    const { user } = useSelector((state) => state.auth);
    const staffData = user?.stuff || {};
    const token = localStorage.getItem("token");
    const baseUrl = 'https://estbn.com/EstbnNew/public/api';
    const [activePopup, setActivePopup] = useState(null); 
    const [isShiftActive, setIsShiftActive] = useState(false);
    const [isPaused, setIsPaused] = useState(false);
    const [shiftId, setShiftId] = useState(null);
    const [breakId, setBreakId] = useState(null);
    const [tripId, setTripId] = useState(null); 
    const [startTime, setStartTime] = useState("");
    const [loading, setLoading] = useState(false);  
    const [isTripActive, setIsTripActive] = useState(false);
    const fileInputRef = useRef(null);
    const [capturedImg, setCapturedImg] = useState(null);
    const [uploadFile, setUploadFile] = useState(null);

    useEffect(() => {
        const savedId = localStorage.getItem("active_shift_id");
        const savedStartTime = localStorage.getItem("shift_start_time");
        const savedIsPaused = localStorage.getItem("is_paused") === "true";
        const savedBreakId = localStorage.getItem("active_break_id");
        const savedTripActive = localStorage.getItem("is_trip_active") === "true";
        const savedTripId = localStorage.getItem("active_trip_id");

        if (savedId) {
            setShiftId(savedId);
            setIsShiftActive(true);
            setStartTime(savedStartTime || "");
            setIsPaused(savedIsPaused);
            setIsTripActive(savedTripActive);
            if (savedBreakId) setBreakId(savedBreakId);
            if (savedTripId) setTripId(savedTripId);
        }
    }, []);

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setUploadFile(file);
            const reader = new FileReader();
            reader.onloadend = () => setCapturedImg(reader.result);
            reader.readAsDataURL(file);
        }
    };

    const resetImageData = () => {
        setCapturedImg(null);
        setUploadFile(null);
    };

    const handleStartShift = async () => {
        if (!uploadFile) return toast.warning("يرجى رفع صورة أولاً");
        setLoading(true);
        try {
            const formData = new FormData();
            formData.append('image_before', uploadFile);

            const response = await fetch(`${baseUrl}/stuff/shifts/start`, {
                method: 'POST',
                headers: { 
                    'Authorization': `Bearer ${token}`, 
                    'Accept': 'application/json' 
                },
                body: formData,
            });
            
            const data = await response.json();
            
            if (response.ok) {
                const newId = data?.data?.shift?.id;
                const timeString = new Date().toLocaleTimeString('ar-EG', { hour: '2-digit', minute: '2-digit', hour12: true });
                setShiftId(newId);
                setStartTime(timeString);
                setIsShiftActive(true);
                localStorage.setItem("active_shift_id", newId);
                localStorage.setItem("shift_start_time", timeString);
                setActivePopup(null);
                resetImageData();
                toast.success("تم بدء الشيفت");
            } else {
                toast.error(data.message || "خطأ في بدء الشيفت");
            }
        } catch (error) {
            toast.error("فشل الاتصال بالسيرفر");
        } finally { setLoading(false); }
    };

    const handleToggleBreak = async () => {
        const currentShiftId = shiftId || localStorage.getItem("active_shift_id");
        setLoading(true);
        try {
            if (!isPaused) {
                const formData = new FormData();
                formData.append('reason', 'lunch time'); 

                const response = await fetch(`${baseUrl}/stuff/shifts/break/start/${currentShiftId}`, {
                    method: 'POST',
                    headers: { 
                        'Authorization': `Bearer ${token}`, 
                        'Accept': 'application/json' 
                    },
                    body: formData
                });

                const data = await response.json();
                
                if (response.ok) {
                    const newBreakId = data?.data?.break?.id;
                    setBreakId(newBreakId);
                    localStorage.setItem("active_break_id", newBreakId);
                    setIsPaused(true);
                    localStorage.setItem("is_paused", "true");
                    setActivePopup(null);
                } else {
                    toast.error(data.message || "فشلت عملية الاستراحة");
                }
            } else {
                const currentBreakId = breakId || localStorage.getItem("active_break_id");
                const response = await fetch(`${baseUrl}/stuff/shifts/break/end/${currentBreakId}`, {
                    method: 'POST',
                    headers: { 
                        'Authorization': `Bearer ${token}`, 
                        'Accept': 'application/json' 
                    }
                });

                if (response.ok) {
                    setIsPaused(false);
                    setBreakId(null);
                    localStorage.setItem("is_paused", "false");
                    localStorage.removeItem("active_break_id");
                    setActivePopup(null);
                } else {
                    const data = await response.json();
                    toast.error(data.message || "فشل إنهاء الاستراحة");
                }
            }
        } catch (error) {
            toast.error("حدث خطأ في الاتصال بالسيرفر");
        } finally { setLoading(false); }
    };

    const handleEndShiftSubmit = async () => {
        const currentShiftId = shiftId || localStorage.getItem("active_shift_id");
        if (!uploadFile) return toast.warning("يرجى رفع صورة الانصراف");
        setLoading(true);
        try {
            const formData = new FormData();
            formData.append('image_after', uploadFile);

            const response = await fetch(`${baseUrl}/stuff/shifts/end/${currentShiftId}`, {
                method: 'POST',
                headers: { 
                    'Authorization': `Bearer ${token}`, 
                    'Accept': 'application/json' 
                },
                body: formData,
            });

            if (response.ok) {
                setIsShiftActive(false);
                setIsPaused(false);
                setShiftId(null);
                setIsTripActive(false);
                setTripId(null);
                
                // مسح كافة بيانات الشيفت من التخزين
                localStorage.removeItem("active_shift_id");
                localStorage.removeItem("shift_start_time");
                localStorage.removeItem("is_paused");
                localStorage.removeItem("active_break_id");
                localStorage.removeItem("is_trip_active");
                localStorage.removeItem("active_trip_id");

                setActivePopup(null);
                resetImageData();
                toast.success("تم إنهاء الشيفت بنجاح");
            } else {
                const data = await response.json();
                toast.error(data.message || "حدث خطأ أثناء إنهاء الشيفت");
            }
        } catch (error) { 
            toast.error("فشل الاتصال بالسيرفر"); 
        } finally { setLoading(false); }
    };

    const handleStartTrip = async () => {
        setLoading(true);
        try {
            const payload = { door_step_order_id: 224 };
            const response = await fetch(`${baseUrl}/stuff/trips/start`, {
                method: 'POST',
                headers: { 
                    'Authorization': `Bearer ${token}`, 
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload),
            });
            const data = await response.json();
            if (response.ok) {
                const newTripId = data?.data?.trip?.id;
                setTripId(newTripId);
                setIsTripActive(true);
                localStorage.setItem("is_trip_active", "true");
                localStorage.setItem("active_trip_id", newTripId);
                toast.success("بدأت الرحلة");
            } else {
                toast.error(data.message || "خطأ في بدء الرحلة");
            }
        } catch (error) {
            toast.error("فشل الاتصال بالسيرفر");
        } finally { setLoading(false); }
    };

    const handleEndTrip = async () => {
        const currentTripId = tripId || localStorage.getItem("active_trip_id");
        if (!currentTripId) return toast.error("لا يوجد رحلة نشطة");

        setLoading(true);
        try {
            const response = await fetch(`${baseUrl}/stuff/trips/end/${currentTripId}`, {
                method: 'POST',
                headers: { 
                    'Authorization': `Bearer ${token}`, 
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            });
            if (response.ok) {
                setIsTripActive(false);
                setTripId(null);
                localStorage.removeItem("is_trip_active");
                localStorage.removeItem("active_trip_id");
                toast.success("انتهت الرحلة");
            } else {
                const data = await response.json();
                toast.error(data.message || "حدث خطأ أثناء إنهاء الرحلة");
            }
        } catch (error) { 
            toast.error("فشل الاتصال بالسيرفر"); 
        } finally { setLoading(false); }
    };

    return (
      <div className="hp-main-wrapper py-4 px-3 px-md-5" dir="rtl">
        {/* Shift */}
        <div
          className={`hp-status-card mb-4 p-4 d-flex justify-content-between align-items-center ${isShiftActive ? (isPaused ? "hp-shift-paused-bg" : "hp-shift-active-bg") : ""}`}
        >
          <div className="d-flex align-items-center gap-3">
            <div
              className={
                isShiftActive ? "hp-avatar-active" : "hp-avatar-placeholder"
              }
            >
              <Person className="text-white" style={{ fontSize: 30 }} />
            </div>
            <div className="text-end">
              <h5 className="hp-fw-bold mb-1">
                {!isShiftActive
                  ? "لم تبدأ الشيفت بعد"
                  : isPaused
                    ? "أنت في استراحة"
                    : "الشيفت شغال"}
              </h5>
              <p className="hp-text-muted small mb-0">
                {isShiftActive
                  ? `بدأ الساعة ${startTime}`
                  : "ابدأ الشيفت بصورة الحضور لعرض الطلبات."}
              </p>
            </div>
          </div>
          <div className="d-flex gap-2">
            {isShiftActive ? (
              <>
                <button
                  onClick={() =>
                    isPaused ? handleToggleBreak() : setActivePopup("pause")
                  }
                  className="btn hp-btn-pause d-flex align-items-center gap-2 px-3 py-2 bg-white border shadow-sm"
                  disabled={loading}
                >
                  <span className="fw-bold">
                    {isPaused ? "استئناف" : "استراحة"}
                  </span>
                  {isPaused ? (
                    <PlayCircleFilled fontSize="small" />
                  ) : (
                    <Pause fontSize="small" />
                  )}
                </button>
                <button
                  onClick={() => setActivePopup("end")}
                  className="btn btn-dark hp-btn-end px-3 py-2"
                  disabled={loading || isTripActive}
                >
                  <span className="fw-bold">انهاء</span>
                </button>
              </>
            ) : (
              <button
                onClick={() => setActivePopup("start")}
                className="btn btn-dark hp-btn-start px-4 py-2 border-0 shadow"
                disabled={loading}
              >
                <span className="fw-bold">ابدأ الشيفت</span>
                <PlayArrow style={{ fontSize: 20 }} />
              </button>
            )}
          </div>
        </div>
        {/* Car Check */}
        <div className="hp-info-card mb-4 p-4 d-flex justify-content-between align-items-center bg-white shadow-sm border-0">
          <div className="text-end">
            <h5 className="hp-fw-bold mb-2">
              {" "}
              بيانات سيارة #{staffData?.current_vehicle?.id || "غير معرف"}
            </h5>
            <p className="hp-text-muted small mb-0">
              {" "}
              اسم السياره :{" "}
              {staffData?.current_vehicle?.name || "غير معرف"}{" "}
            </p>
            <p className="hp-text-muted small mb-0">
              {" "}
              الموديل : {staffData?.current_vehicle?.year || "غير معرف"}{" "}
            </p>
            <p className="hp-text-muted small mb-0">
              {" "}
              رقم اللوحة :{" "}
              {staffData?.current_vehicle?.plate_number || "غير معرف"}{" "}
            </p>
          </div>
          <div className="d-flex flex-column align-items-center gap-2">
            <div className=" rounded-2 overflow-hidden">
              <img
                src={
                  staffData?.current_vehicle?.profile_photo_path
                    ? `https://estbn.com/EstbnNew/public${
                        staffData?.current_vehicle?.profile_photo_path
                      }`
                    : key
                }
                alt="wrench"
                width="85"
              />
            </div>
            <div
              onClick={() => navigate("/checkCar")}
              className="hp-link-action fw-semibold text-dark small"
              style={{ cursor: "pointer" }}
            >
              افحص السياره <ChevronLeft fontSize="small" />
            </div>
          </div>
        </div>
        {/* بطاقة الطلبات والرحلة */}
        <div className="hp-info-card mb-4 p-4 bg-white shadow-sm border-0">
          <div className="d-flex justify-content-between align-items-start mb-3">
            <div className="text-end">
              <h5 className="hp-fw-bold mb-3">طلبات اليوم</h5>
              <div className="hp-text-muted small">
                <div>عدد الطلبات: 6 طلبات</div>
                <div className="mt-2 text-dark">
                  <span className="fw-bold">الطلب القادم : طلب #ORD-3247</span>
                  <br />
                  <span className="hp-text-muted">
                    • مدينة نصر، شارع الطيران
                  </span>
                </div>
              </div>
            </div>
            <div
              onClick={() => navigate("/dayOrders")}
              className="hp-link-action fw-bold text-dark small"
              style={{ cursor: "pointer" }}
            >
              <ChevronLeft fontSize="small" /> عرض الكل
            </div>
          </div>
          <div className="text-center mt-3">
            {!isTripActive ? (
              <button
                onClick={handleStartTrip}
                disabled={!isShiftActive || isPaused || loading}
                className="btn btn-dark py-2 w-25 mx-auto rounded-3 d-flex align-items-center justify-content-center gap-2"
              >
                <span className="fw-bold">ابدأ الرحلة</span>
                <LocationOn fontSize="small" />
              </button>
            ) : (
              <button
                onClick={handleEndTrip}
                disabled={loading}
                className="btn btn-danger py-2 w-25 mx-auto rounded-3 d-flex align-items-center justify-content-center gap-2"
              >
                <span className="fw-bold">إنهاء الرحلة</span>
                <StopCircle fontSize="small" />
              </button>
            )}
          </div>
        </div>
        {/* طلب المساعدة */}
        <div className="hp-info-card mb-4 p-4 hp-sos-card border-warning-subtle shadow-sm text-center">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div className="text-end">
              <h5 className="hp-fw-bold mb-2">طلب مساعدة علي الطريق</h5>
              <p className="hp-text-muted mb-0">
                واجهت مشكلة؟ أرسل بلّغ سريع لفريق الدعم
              </p>
            </div>
            <img src={sos} alt="sos" width="65" />
          </div>
          <button className="btn btn-dark w-25 mx-auto py-2 fw-bold rounded-3">
            ارسل طلب مساعدة
          </button>
        </div>
        {/* Popups الحضور والانصراف */}
        {(activePopup === "start" || activePopup === "end") && (
          <div className="hp-modal-overlay">
            <div className="hp-modal-content p-4 text-center">
              <h4 className="fw-bold mb-3">
                {activePopup === "start" ? "إثبات حضور" : "إثبات انصراف"}
              </h4>
              <p className="hp-text-muted small">
                يرجى رفع صورة شخصية لتوثيق الحالة
              </p>
              <input
                type="file"
                accept="image/*"
                ref={fileInputRef}
                style={{ display: "none" }}
                onChange={handleFileChange}
              />
              <div
                className="my-4 rounded-4 border d-flex align-items-center justify-content-center overflow-hidden"
                style={{
                  height: "220px",
                  background: "#f8f9fa",
                  cursor: "pointer",
                }}
                onClick={() => fileInputRef.current.click()}
              >
                {capturedImg ? (
                  <img
                    src={capturedImg}
                    alt="preview"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                ) : (
                  <div className="text-center">
                    <CloudUpload style={{ fontSize: 50, color: "#ccc" }} />
                    <p className="text-muted small mt-2">اضغط لرفع صورة</p>
                  </div>
                )}
              </div>
              <div className="d-flex flex-column gap-2">
                <button
                  onClick={
                    activePopup === "start"
                      ? handleStartShift
                      : handleEndShiftSubmit
                  }
                  disabled={loading}
                  className="btn btn-dark py-3 fw-bold rounded-3"
                >
                  {loading ? (
                    <span className="spinner-border spinner-border-sm"></span>
                  ) : activePopup === "start" ? (
                    "بدء الشيفت الآن"
                  ) : (
                    "تأكيد الإنهاء"
                  )}
                </button>
                {capturedImg && (
                  <button
                    onClick={resetImageData}
                    className="btn btn-light border py-2"
                  >
                    <Replay fontSize="small" /> تغيير الصورة
                  </button>
                )}
                <button
                  onClick={() => {
                    setActivePopup(null);
                    resetImageData();
                  }}
                  className="btn btn-link text-muted"
                >
                  إلغاء
                </button>
              </div>
            </div>
          </div>
        )}
        {/* Popup الاستراحة */}
        {activePopup === "pause" && (
          <div className="hp-modal-overlay">
            <div
              className="hp-modal-content p-4 text-center"
              style={{ maxWidth: "350px" }}
            >
              <h4 className="fw-bold mb-3">بدء استراحة</h4>
              <p className="hp-text-muted">
                هل تريد التوقف مؤقتاً لأخذ استراحة؟
              </p>
              <div className="d-flex flex-column gap-2">
                <button
                  onClick={handleToggleBreak}
                  className="btn btn-warning py-3 fw-bold text-white rounded-3"
                  disabled={loading}
                >
                  تأكيد الاستراحة
                </button>
                <button
                  onClick={() => setActivePopup(null)}
                  className="btn btn-light border py-2"
                >
                  تراجع
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
};

export default Home;